export enum PreviousInsuranceCancellationReasons {
  SELF_CANCELLATION = 'SELF_CANCELLATION',
  INSURER_ADVISED = 'INSURER_ADVISED',
  PAYMENT_ISSUES = 'PAYMENT_ISSUES',
  ANOTHER_REASON = 'ANOTHER_REASON',
  DECLARED_UNKNOWN = 'DECLARED_UNKNOWN',
  ADDITIONAL_DRIVER_CANCELLED = 'ADDITIONAL_DRIVER_CANCELLED',
}

export const PreviousInsuranceCancellationReasonsMap = {
  [PreviousInsuranceCancellationReasons.SELF_CANCELLATION]:
    'It was my choice to cancel (e.g. I no longer needed car insurance)',
  [PreviousInsuranceCancellationReasons.INSURER_ADVISED]:
    'My insurer advised me to cancel (e.g due to a change I was making)',
  [PreviousInsuranceCancellationReasons.PAYMENT_ISSUES]:
    'My insurer cancelled or voided my policy because of payment issues',
  [PreviousInsuranceCancellationReasons.ANOTHER_REASON]:
    'My insurer cancelled or voided my policy for another reason',
  [PreviousInsuranceCancellationReasons.DECLARED_UNKNOWN]: 'I’m not sure / I don’t know',
  [PreviousInsuranceCancellationReasons.ADDITIONAL_DRIVER_CANCELLED]:
    'Additional driver policy cancelled/voided',
}
